import {
  Box,
  Button,
  Typography,
  styled,
  Select,
  MenuItem,
} from "@mui/material";
export const svgCode = `
<svg width="347" height="697" viewBox="0 0 347 697" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M112.089 -24.3145C142.396 -3.0752 93.5976 183.021 240.45 183.021C318.001 183.021 301.288 335.067 348.086 345.855" stroke="#F6F5FA" stroke-width="2" opacity="0.2"/>
<path d="M196.326 -73.8727C226.634 -52.6334 177.835 133.463 324.687 133.463C402.239 133.463 385.525 285.509 432.323 296.297" stroke="#F6F5FA" stroke-width="2" opacity="0.2"/>
<path d="M-21.6201 105.887C27.5693 92.4078 128.279 92.3885 108.078 171.864C74.6506 303.377 153.354 432.581 363.463 458.12" stroke="#F6F5FA" stroke-width="2" opacity="0.2"/>
<path d="M-112.543 154.905C-51.7399 138.27 72.7482 138.246 47.7778 236.328C6.45787 398.63 103.744 558.082 363.462 589.601" stroke="#F6F5FA" stroke-width="2" opacity="0.2"/>
<path d="M-175.387 236.915C-106.556 218.077 34.3672 218.05 6.10003 329.12C-40.675 512.914 69.4546 693.481 363.461 729.173" stroke="#F6F5FA" stroke-width="2" opacity="0.2"/>
</svg>
`;
const svg2 = `
<svg width="347" height="698" viewBox="0 0 347 698" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M112.089 -12.2858C142.396 11.169 93.5976 216.677 240.45 216.677C318.001 216.677 301.288 384.583 348.086 396.497" stroke="#00EEFF" stroke-width="2" opacity="0.2"/>
<path d="M196.326 -67.0135C226.634 -43.5588 177.835 161.949 324.687 161.949C402.239 161.949 385.525 329.855 432.323 341.769" stroke="#00EEFF" stroke-width="2" opacity="0.2"/>
<path d="M-21.6201 131.497C27.5693 116.612 128.279 116.591 108.078 204.357C74.6506 349.587 153.354 492.268 363.463 520.472" stroke="#00EEFF" stroke-width="2" opacity="0.2"/>
<path d="M-112.543 185.628C-51.7399 167.258 72.7482 167.232 47.7778 275.545C6.45787 454.776 103.744 630.861 363.462 665.668" stroke="#00EEFF" stroke-width="2" opacity="0.2"/>
<path d="M-175.387 276.193C-106.556 255.39 34.3672 255.36 6.10003 378.016C-40.675 580.981 69.4546 780.383 363.461 819.799" stroke="#00EEFF" stroke-width="2" opacity="0.2"/>
</svg>`;
export const CustomSelect = styled(Select)({
  background: "#27B1BB",
  // boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  borderRadius: "5px",
  color: "#FFFFFF",
  border: "none",
});
export const CustomSelect2 = styled(Select)({
  background: "#FFFFFF",
  // boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  borderRadius: "5px",
  color: "#000",
  border: "none",
  minWidth: "150px",
});
export const CustomMenuItem = styled(MenuItem)({
  //background: "#27B1BB",
  //color: "#FFFFFF",
  "&:hover": { background: "#27B1BB", color: "white" },
  "&:active": { background: "#27B1BB", color: "white" },
  "&.Mui-selected": {
    background: "#27B1BB",
    color: "white",
  },
  "&.Mui-selected:hover": {
    background: "#27B1BB",
    color: "white",
  },
});
export const CountBox = styled(Box)({
  height: "34px",
  width: "43px",
  background: "#FFFFFF",
  borderRadius: "5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
export const CardBox = styled(Box)({
  minHeight: "120px",
  maxHeight: { md: "200px", sx: "523px", xs: "523px" },

  background: "#EBEBEB",
  backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(svg2)}")`,
  border: "4px solid #27B1BB",
  padding: "20px",
  boxShadow: "6px 12px 32px rgba(0, 0, 0, 0.12)",
  borderRadius: "10px",
});
export const SaveBox = styled(Box)({
  width: "91px",
  height: "31px",
  background: "#FFFFFF",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
export const DetailsBox = styled(Box)(({ theme }) => ({
  background: "#27B1BB",
  borderRadius: "10px",
  // width: "311px",
  // height: "150px",
  display: "flex",
  flexDirection: "column",
  rowGap: "10px",
  alignItems: "center",
  justifyContent: "center",
  padding: "8px",
  [theme.breakpoints.down("sm")]: {
    width: "250px",
  },
}));
export const Btn = styled(Button)(({ theme }) => ({
  background: "#27B1BB",
  textTransform: "none",
  borderRadius: "5px",
  fontSize: "16px",
  fontFamily: "Inter",
  fontWeight: 700,
  color: "#000000",
  filter: "drop-shadow(0px 4px 0px #27B1BB)",
  [theme.breakpoints.down("sm")]: {
    width: "135px",
  },
}));
export const FeatureBox = styled(Box)(({ theme }) => ({
  background: "#EBEBEB",
  borderRadius: "10px",
  height: "31px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "285px",
  [theme.breakpoints.down("sm")]: {
    width: "230px",
  },
}));
export const CardTitle = styled(Typography)(({ theme }) => ({
  fontSize: "30px",
  fontFamily: "Poppins",
  fontWeight: 800,
  color: "#27B1BB",
  textAlign: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: "24px",
  },
}));
export const Title = styled(Typography)(({ theme }) => ({
  margin: "20px 0 10px 0",
  fontSize: "28px",
  fontFamily: "Poppins",
  fontWeight: 700,
  textAlign: "center",

  [theme.breakpoints.down("md")]: {
    fontSize: "26px",
  },
}));
export const FeatureText = styled(Typography)(({ theme }) => ({
  color: "#000000",
  fontSize: "14px",
  fontFamily: "Poppins",
  fontWeight: 500,
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
  },
}));
